import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import individual from "../../assets/individualTaxes.png";
import services from "../../assets/individualTaxesServices.png";

export default function IndividualTaxFiling() {
    useEffect(() => {
        AOS.init({ once: true, duration: 850, easing: "ease-in-out" });
    }, []);

    return (
        <div style={{ minHeight: "100vh", background: "#fff" }}>
            <div style={{ height: 72 }} /> {/* Header spacing */}

            {/* Hero Heading */}
            <section className="container py-5">
                <div className="row align-items-center" data-aos="fade-down">
                    <div className="col-lg-8">
                        <h1 className="fw-bold mb-3" style={{ 
                            fontFamily: "Poppins, sans-serif", 
                            color: "#6B46C1",
                            fontSize: "2.5rem"
                        }}>
                            Individual Tax Filing
                        </h1>
                        <div className="fs-5 text-secondary mb-4" style={{ lineHeight: "1.8" }}>
                            Our team of experienced tax professionals will prepare your individual tax return with accuracy and care.
                            We'll ensure you take advantage of all eligible deductions and credits, minimizing your tax liability and maximizing your refund.
                        </div>
                    </div>
                    <div className="col-lg-4 text-center d-none d-lg-block" data-aos="zoom-in">
                        <img
                            src={individual}
                            alt="Individual Tax Filing"
                            className="rounded-4 shadow-lg"
                            style={{ width: "100%", maxWidth: "400px" }}
                        />
                    </div>
                </div>
            </section>

            {/* Individual Taxes Section */}
            <section className="container py-5" data-aos="fade-right">
                <div className="row my-5 align-items-center">
                    <div className="col-lg-6 order-lg-1 order-2">
                        <h2 className="fw-bold mb-4" style={{ 
                            color: "#6B46C1", 
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "2rem"
                        }}>
                            Individual Taxes
                        </h2>
                        <p className="fs-5 mb-4 text-secondary" style={{ lineHeight: "1.8" }}>
                            Our team of experienced tax professionals will prepare your individual tax return with accuracy and care.
                            We'll ensure you take advantage of all eligible deductions and credits, minimizing your tax liability and maximizing your refund.
                        </p>
                        
                        <h5 className="mt-5 mb-3 fw-bold" style={{ 
                            color: "#D53F8C",
                            fontFamily: "Poppins, sans-serif"
                        }}>
                            Types of Individual Tax Returns
                        </h5>
                        
                        <div className="mb-4">
                            <div className="card border-0 shadow-sm mb-4" style={{
                                background: "linear-gradient(135deg, #f7f8ff 0%, #f8e0f5 100%)",
                                borderRadius: "1rem"
                            }}>
                                <div className="card-body p-4">
                                    <h6 className="fw-bold mb-3" style={{ 
                                        color: "#6B46C1",
                                        fontSize: "1.3rem"
                                    }}>
                                        Form 1040
                                    </h6>
                                    <ul className="mb-0" style={{ lineHeight: "1.8" }}>
                                        <li className="mb-2">
                                            <b style={{ color: "#344476" }}>Purpose:</b> The standard federal income tax form used by U.S. taxpayers to report their annual earnings and calculate their tax liability or refund.
                                        </li>
                                        <li className="mb-2">
                                            <b style={{ color: "#344476" }}>Eligibility:</b> U.S. citizens, Green Card holders, and residents (for tax purposes) use this form to report their worldwide income.
                                        </li>
                                        <li>
                                            <b style={{ color: "#344476" }}>Deductions and Credits:</b> Offers various deductions and credits, such as mortgage interest, state and local taxes, healthcare costs, and charitable contributions.
                                        </li>
                                        <li>
                                            <b style={{ color: "#344476" }}>Scheule C:</b> Used by sole proprietors and single-member LLCs to report business income and expenses on their personal tax return.
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="card border-0 shadow-sm" style={{
                                background: "linear-gradient(135deg, #f8e0f5 0%, #f7f8ff 100%)",
                                borderRadius: "1rem"
                            }}>
                                <div className="card-body p-4">
                                    <h6 className="fw-bold mb-3" style={{ 
                                        color: "#6B46C1",
                                        fontSize: "1.3rem"
                                    }}>
                                        Form 1040NR
                                    </h6>
                                    <ul className="mb-0" style={{ lineHeight: "1.8" }}>
                                        <li className="mb-2">
                                            <b style={{ color: "#344476" }}>Purpose:</b> Used by nonresident aliens to report their U.S.-sourced income and claim any applicable treaty benefits.
                                        </li>
                                        <li className="mb-2">
                                            <b style={{ color: "#344476" }}>Eligibility:</b> Nonresident aliens who have U.S.-sourced income, but do not meet the criteria for resident status, use this form.
                                        </li>
                                        <li>
                                            <b style={{ color: "#344476" }}>Deductions and Credits:</b> Offers limited deductions and credits compared to Form 1040.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 order-lg-2 order-1 mb-4 mb-lg-0 text-center" data-aos="zoom-in">
                        <img
                            src={individual}
                            alt="Individual Tax"
                            className="rounded-4 shadow-lg"
                            style={{ width: "100%", maxWidth: "500px" }}
                        />
                    </div>
                </div>
            </section>

            {/* Individual Tax Services Section */}
            <section className="container py-5" data-aos="fade-left">
                <div className="row my-5 align-items-center">
                    <div className="col-lg-6 text-center mb-4 mb-lg-0" data-aos="flip-left">
                        <img
                            src={services}
                            alt="Individual Tax Services"
                            className="rounded-4 shadow-lg"
                            style={{ width: "100%", maxWidth: "400px" }}
                        />
                    </div>
                    <div className="col-lg-6">
                        <h2 className="fw-bold mb-4" style={{ 
                            color: "#D53F8C",
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "2rem"
                        }}>
                            Individual Tax Services
                        </h2>
                        <div className="row g-3">
                            <div className="col-md-6">
                                <div className="card border-0 shadow-sm h-100" style={{
                                    background: "linear-gradient(135deg, #edeaff 0%, #fff5fb 100%)",
                                    borderRadius: "1rem",
                                    transition: "transform 0.3s ease"
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                                onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                                    <div className="card-body p-4">
                                        <h6 className="fw-bold mb-2" style={{ color: "#6B46C1" }}>
                                            <i className="bi bi-file-earmark-text me-2"></i>Tax Preparation
                                        </h6>
                                        <p className="mb-0 text-secondary">
                                            Accurate preparation of your individual tax return
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card border-0 shadow-sm h-100" style={{
                                    background: "linear-gradient(135deg, #fff5fb 0%, #edeaff 100%)",
                                    borderRadius: "1rem",
                                    transition: "transform 0.3s ease"
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                                onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                                    <div className="card-body p-4">
                                        <h6 className="fw-bold mb-2" style={{ color: "#6B46C1" }}>
                                            <i className="bi bi-calendar-check me-2"></i>Tax Planning
                                        </h6>
                                        <p className="mb-0 text-secondary">
                                            Strategic planning to minimize tax liability and maximize refunds
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card border-0 shadow-sm h-100" style={{
                                    background: "linear-gradient(135deg, #edeaff 0%, #fff5fb 100%)",
                                    borderRadius: "1rem",
                                    transition: "transform 0.3s ease"
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                                onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                                    <div className="card-body p-4">
                                        <h6 className="fw-bold mb-2" style={{ color: "#6B46C1" }}>
                                            <i className="bi bi-shield-check me-2"></i>Tax Audit Representation
                                        </h6>
                                        <p className="mb-0 text-secondary">
                                            Representation before the IRS in case of an audit
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card border-0 shadow-sm h-100" style={{
                                    background: "linear-gradient(135deg, #fff5fb 0%, #edeaff 100%)",
                                    borderRadius: "1rem",
                                    transition: "transform 0.3s ease"
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                                onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                                    <div className="card-body p-4">
                                        <h6 className="fw-bold mb-2" style={{ color: "#6B46C1" }}>
                                            <i className="bi bi-cash-stack me-2"></i>Tax Debt Resolution
                                        </h6>
                                        <p className="mb-0 text-secondary">
                                            Assistance with resolving tax debt and other tax-related issues
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-5 my-5" style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                borderRadius: "2rem"
            }}>
                <div className="container text-center text-white">
                    <h2 className="fw-bold mb-4" style={{ 
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "2rem"
                    }}>
                        Ready to Maximize Your Tax Refund?
                    </h2>
                    <p className="lead mb-5 fs-5" style={{ opacity: 0.95 }}>
                        Contact Nexen Consulting's expert tax professionals today to get tailored guidance and seamless individual tax filing support.
                    </p>
                    <Link
                        to="/contact"
                        className="btn btn-light btn-lg rounded-pill fw-bold px-5 py-3"
                        style={{
                            background: "#fff",
                            color: "#6B46C1",
                            border: "none",
                            boxShadow: "0 4px 15px rgba(255, 255, 255, 0.3)",
                            transition: "transform 0.3s ease, box-shadow 0.3s ease"
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "scale(1.05)";
                            e.currentTarget.style.boxShadow = "0 8px 30px rgba(255, 255, 255, 0.5)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                            e.currentTarget.style.boxShadow = "0 4px 15px rgba(255, 255, 255, 0.3)";
                        }}
                    >
                        Get in Touch
                    </Link>
                </div>
            </section>
        </div>
    );
}

